// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const PurchaseOrderCustomerOrderViewPurchaseOrderStateValues = [
	"INITIAL",
	"RELEASED",
	"CONFIRMED",
	"PARTIALLY_RECEIVED",
	"RECEIVED",
	"CANCELLED",
] as const;

export type PurchaseOrderCustomerOrderViewPurchaseOrderState =
	(typeof PurchaseOrderCustomerOrderViewPurchaseOrderStateValues)[number];

export const getPurchaseOrderCustomerOrderViewPurchaseOrderStateLabels = () => ({
	INITIAL: t("initial"),
	RELEASED: t("released"),
	CONFIRMED: t("confirmed"),
	PARTIALLY_RECEIVED: t("partially_received"),
	RECEIVED: t("received"),
	CANCELLED: t("cancelled"),
});

export const getPurchaseOrderCustomerOrderViewPurchaseOrderStateLabel = (
	value: PurchaseOrderCustomerOrderViewPurchaseOrderState,
): string => {
	return getPurchaseOrderCustomerOrderViewPurchaseOrderStateLabels()[value];
};
